export default "__VITE_ASSET__DIvdEQbP__"